import type { SupportedGeometryType, VectorSourceDescriptor } from '../data/model';

export type GeometryFamily = 'point' | 'line' | 'polygon';

function familyForType(type: SupportedGeometryType): GeometryFamily {
  if (type === 'Point' || type === 'MultiPoint') return 'point';
  if (type === 'LineString' || type === 'MultiLineString') return 'line';
  return 'polygon';
}

export function geometryFamiliesForSource(
  source: VectorSourceDescriptor,
): readonly GeometryFamily[] {
  return [...new Set(source.geometry.types.map(familyForType))];
}

/** Renderer-independent geometry semantics for layer-list and legend symbols. */
export function symbolGeometryForSource(source: VectorSourceDescriptor): GeometryFamily | 'mixed' {
  const families = geometryFamiliesForSource(source);
  return families.length === 1 ? (families[0] ?? 'mixed') : 'mixed';
}
